import { z } from 'zod'
import { Platform } from 'interfaces/channel.interface'

export const agentScheduleSchema = z.object({
  start: z.string().min(1, 'กรุณาระบุเวลาเริ่มต้น'),
  end: z.string().min(1, 'กรุณาระบุเวลาสิ้นสุด'),
})

const partialScheduleSchema = z
  .object({
    start: z.string().optional(),
    end: z.string().optional(),
  })
  .optional()

export const agentConfigSchema = z
  .object({
    isActive: z.boolean().default(false),
    isNotify: z.boolean().default(false),
    isAlwaysOn: z.boolean().default(false),
    weekday: partialScheduleSchema,
    weekend: partialScheduleSchema,
  })
  .superRefine((data, ctx) => {
    if (data.isAlwaysOn) return

    const periods = ['weekday', 'weekend'] as const
    for (const period of periods) {
      const schedule = data[period]
      if (!schedule?.start) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'กรุณาระบุเวลาเริ่มต้น',
          path: [period, 'start'],
        })
      }
      if (!schedule?.end) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'กรุณาระบุเวลาสิ้นสุด',
          path: [period, 'end'],
        })
      }
    }
  })

export const agentSettingsSchema = z.object({
  chat: agentConfigSchema,
  comment: agentConfigSchema,
})

export const channelFormSchema = z.object({
  name: z.string().min(1, 'กรุณากรอกชื่อบัญชี'),
  platform: z.nativeEnum(Platform),
  agentSettings: agentSettingsSchema,
})

export type ChannelFormSchema = z.infer<typeof channelFormSchema>
